goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_right_svg");
goog.provide("module$shadow_js_shim_module$src$svg$chevron$chevron_right_svg");
shadow.js.shim.module$src$svg$chevron$chevron_right_svg = shadow.js.nativeProvides["src/svg/chevron/chevron-right.svg"] = shadow$bridge("src/svg/chevron/chevron-right.svg");
module$shadow_js_shim_module$src$svg$chevron$chevron_right_svg.default = shadow.js.shim.module$src$svg$chevron$chevron_right_svg;
